import { render, staticRenderFns } from "./loanproductPermissions.vue?vue&type=template&id=72b59a32"
import script from "./loanproductPermissions.vue?vue&type=script&lang=js"
export * from "./loanproductPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports